import { httpClient, postProcessUpsert } from "@genai/http-client";
import { AssistantId } from "@genai/assistant";
import { ChatId, Chat, MessageId, ApiChat } from "../model";
import { CollectionId } from "@genai/collection";

export function editChat(
    assistantId: AssistantId,
    chatId: ChatId,
    messageId: MessageId,
    content: object,
) {
  return httpClient(`/assistants/${assistantId}/chats/${chatId}/messages/${messageId}/rate`, {
    method: "PUT",
    body: JSON.stringify(content),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(postProcessUpsert);
}

export function updateChat(
  assistantId: AssistantId,
  chatId: ChatId,
  collectionId: CollectionId,
  name: string,
) {
  return httpClient(`/assistants/${assistantId}/chats/${chatId}`, {
    method: "PUT",
    body: JSON.stringify({
      name: name,
      collection: collectionId,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(postProcessUpsert<ApiChat>)
    .then((chat) => chat as Chat);
}
